(function(){
  'use strict';
  var root=document.querySelector('[data-wynch-doi-popup]');
  if(!root)return;
  var locale=root.dataset.locale==='en'?'en':'de';
  var source='site_article_popup_'+locale;
  var form=root.querySelector('[data-wynch-doi-popup-form]');
  var status=root.querySelector('[data-wynch-doi-popup-status]');
  var submit=form.querySelector('[type=submit]');
  var previousFocus=null;
  var storageKey='wynch_site_article_popup_v1_'+locale;
  var delayElapsed=false;
  var scrollReached=false;
  var pendingShown=false;
  function readState(){try{return JSON.parse(localStorage.getItem(storageKey)||'null')}catch(error){return null}}
  function saveState(submitted){try{localStorage.setItem(storageKey,JSON.stringify({at:Date.now(),submitted:!!submitted}))}catch(error){}}
  function eligible(){
    try { var shared=JSON.parse(localStorage.getItem('wynch_article_club_confirmed_ui_v1')||'null');if(shared&&(shared.confirmedAt||shared.state&&shared.state!=='entry'))return false; } catch(error){}
    var global=document.querySelector('[data-wynch-club-global]');
    if(global&&global.dataset.customerClubConfirmed==='true')return false;
    if(window.WynchClubFlowV1&&window.WynchClubFlowV1.hasActiveReceipt&&window.WynchClubFlowV1.hasActiveReceipt())return false;
    var state=readState();return !state||(!state.submitted&&Date.now()-state.at>86400000);
  }
  function close(submitted){root.hidden=true;document.body.style.removeProperty('overflow');saveState(submitted||pendingShown);if(previousFocus&&previousFocus.focus)previousFocus.focus()}
  function showPending(){
    var heading=root.querySelector('#wynch-doi-popup-title'),body=root.querySelector('.wynch-doi-popup__copy');
    if(!root.dataset.entrySaved){root.dataset.entrySaved='true';root.dataset.entryTitle=heading.textContent;root.dataset.entryCopy=body.textContent;root.dataset.entrySubmit=submit.textContent}
    var shared=null;try{shared=JSON.parse(localStorage.getItem('wynch_article_club_confirmed_ui_v1')||'null')}catch(error){}
    var state=shared&&(shared.state||(shared.confirmedAt?'confirmed':'entry'))||'pending';
    root.dataset.clubUiState=state;
    if(state==='entry'){
      pendingShown=false;
      heading.textContent=root.dataset.entryTitle;body.textContent=root.dataset.entryCopy;
      Array.from(form.children).forEach(function(child){child.hidden=child===status});
      form.querySelectorAll('input').forEach(function(input){input.required=true});
      submit.disabled=false;submit.textContent=root.dataset.entrySubmit;status.textContent='';
      return;
    }
    pendingShown=true;saveState(true);
    root.querySelector('#wynch-doi-popup-title').textContent=state==='claimed'?(locale==='en'?'YOUR GIFTS ARE IN YOUR CART':'DEINE GESCHENKE SIND IM WARENKORB'):state==='confirmed'?(locale==='en'?'YOUR GIFTS ARE READY':'DEINE GESCHENKE SIND BEREIT'):(locale==='en'?'CHECK YOUR EMAIL':'PRÜFE DEINE E-MAIL');
    root.querySelector('.wynch-doi-popup__copy').textContent=state==='pending'?(locale==='en'?'Open the confirmation email and confirm your subscription to activate your gifts.':'Öffne die Bestätigungs-E-Mail und bestätige deine Anmeldung, um deine Geschenke zu aktivieren.'):(locale==='en'?'Your complimentary Cava and 30% off your first order.':'Deine kostenlose Cava und 30 % auf deine erste Bestellung.');
    Array.from(form.children).forEach(function(child){if(child!==status&&child!==submit)child.hidden=true});
    form.querySelectorAll('input').forEach(function(input){input.required=false});
    submit.hidden=false;submit.disabled=false;
    submit.textContent=state==='claimed'?(locale==='en'?'OPEN MY CART':'WARENKORB ÖFFNEN'):state==='confirmed'?(locale==='en'?'CLAIM MY CAVA':'MEINE CAVA SICHERN'):(locale==='en'?'CHECK YOUR EMAIL':'PRÜFE DEINE E-MAIL');
    status.textContent=state==='pending'?(locale==='en'?'Waiting for your confirmation.':'Wir warten auf deine Bestätigung.') : '';
    status.hidden=false;
  }
  function maybeOpen(){
    if(!delayElapsed||!scrollReached||!eligible()||!root.hidden)return;
    previousFocus=document.activeElement;root.hidden=false;document.body.style.overflow='hidden';
    form.elements.email.focus();
  }
  function onScroll(){var available=Math.max(1,document.documentElement.scrollHeight-innerHeight);scrollReached=scrollY/available>=.5;maybeOpen()}
  root.querySelectorAll('[data-wynch-doi-popup-close]').forEach(function(node){node.addEventListener('click',function(){close(false)})});
  root.addEventListener('keydown',function(event){if(event.key==='Escape')close(false)});
  addEventListener('wynch:club-delivery-failed',function(){try{localStorage.removeItem(storageKey)}catch(error){}});
  form.addEventListener('submit',function(event){
    event.preventDefault();
    if(root.dataset.clubUiState&&root.dataset.clubUiState!=='entry'&&window.WynchClubFlowV1){
      if(root.dataset.clubUiState==='pending')window.WynchClubFlowV1.renderState(null,true,true);
      else window.WynchClubFlowV1.resend().catch(function(){status.textContent=locale==='en'?'Please try again.':'Bitte versuche es erneut.'});
      return;
    }
    if(!form.reportValidity())return;
    if(!window.WynchClubFlowV1||typeof window.WynchClubFlowV1.register!=='function'){
      status.textContent=locale==='en'?'Please try again in a moment.':'Bitte versuche es gleich erneut.';return;
    }
    submit.disabled=true;status.textContent='';
    window.WynchClubFlowV1.register({
      source:source,channelId:source,email:form.elements.email.value.trim(),locale:locale,
      returnPath:location.pathname+location.search+location.hash
    }).then(function(result){
      if(result.state==='doi_requested'||result.state==='awaiting_doi_confirmation'||result.state==='pending'||result.state==='confirmed'){close(true);window.WynchClubFlowV1.renderState(result,true,true)}
      else{status.textContent=locale==='en'?'Please try again.':'Bitte versuche es erneut.';submit.disabled=false}
    }).catch(function(){status.textContent=locale==='en'?'We could not send the confirmation email. Please try again.':'Wir konnten die Bestätigungs-E-Mail nicht senden. Bitte versuche es erneut.';submit.disabled=false});
  });
  addEventListener('wynch:club-enrollment-registered',function(event){if(event.detail&&event.detail.uiOnly&&!root.hidden)showPending()});
  addEventListener('storage',function(event){if(event.key==='wynch_article_club_confirmed_ui_v1'&&!root.hidden)showPending()});
  addEventListener('scroll',onScroll,{passive:true});onScroll();
  setTimeout(function(){delayElapsed=true;maybeOpen()},8000);
})();
